module.exports = __webpack_public_path__ + "static/4.ad0a3ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling/4.png
// module id = 884
// module chunks = 230667518368419 245178253630338